import React from 'react';
import { careProviderConfiguration } from 'store';
import { useAtom } from 'jotai';

const CareProviderLogo = ({
  size = 'small',
}: {
  size?: 'large' | 'medium' | 'small';
}) => {
  const [careProviderStyles] = useAtom(careProviderConfiguration);
  const getSize = () => {
    if (size === 'large') return '100px';
    else if (size === 'medium') return '50px';
    else return '25px';
  };
  return (
    <img
      style={{ width: 'auto', height: getSize() }}
      src={careProviderStyles.logo}
      data-cy="whitelabel-logo"
    />
  );
};
export default CareProviderLogo;
